const StampIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6001 25.4161H27.4C28.2557 25.4152 28.9703 25.4144 29.5931 25.623C31.2569 26.1802 32.3976 27.73 32.7754 29.4925C32.9172 30.1543 32.917 30.9246 32.9167 32.0625C32.9172 32.5924 32.9176 33.3189 32.8322 33.7175C32.6085 34.761 31.9171 35.7493 30.8284 36.1139C30.4141 36.2527 29.951 36.2511 29.5549 36.2499L10.4452 36.2499C10.0491 36.2511 9.58597 36.2527 9.17168 36.1139C8.08303 35.7493 7.39163 34.761 7.16793 33.7175C7.0825 33.3189 7.08291 32.5923 7.08335 32.0625C7.08306 30.9246 7.08286 30.1543 7.22472 29.4925C7.60253 27.73 8.74317 26.1802 10.407 25.623C11.0297 25.4144 11.7444 25.4152 12.6001 25.4161Z"
        fill="#0051FF"
      />
      <path
        opacity="0.4"
        d="M21.9658 23.0832H18.0345L17.6129 26.5058C17.5041 27.3887 16.7126 28.0147 15.8449 27.904C14.9772 27.7933 14.362 26.9879 14.4708 26.105L15.206 20.1371C15.2846 19.2413 14.7838 18.2324 13.841 17.0308C12.741 15.629 12.0835 13.8433 12.0835 11.9062C12.0835 7.42529 15.6049 3.75 20.0002 3.75C24.3955 3.75 27.9168 7.42529 27.9168 11.9062C27.9168 13.8433 27.2593 15.629 26.1593 17.0308C25.2165 18.2324 24.7157 19.2413 24.7944 20.1371L25.5295 26.105C25.6383 26.9879 25.0231 27.7933 24.1554 27.904C23.2878 28.0147 22.4962 27.3887 22.3875 26.5058L21.9658 23.0832Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default StampIcon;
